export default __webpack_public_path__ + "static/media/OGYA LOGO-01 1.b9a1df90.png";